import { render, staticRenderFns } from "./RequisitionBuyerListMenu.vue?vue&type=template&id=da9cb92c&"
import script from "./RequisitionBuyerListMenu.vue?vue&type=script&lang=ts&"
export * from "./RequisitionBuyerListMenu.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports